import { TopicData } from "./schema";

export function idForClip(): string {
  return crypto.randomUUID();
}

export function idForSeries(): string {
  return crypto.randomUUID();
}

export function idForMap(data: TopicData[]): string {
  if (data.length > 0) {
    // A map path's data is a latitude/longitude pair for one file. Build the
    // id from the server-assigned message-path ids (unique per file) so two
    // paths sharing a topic name across different files get distinct ids.
    return data
      .map((d) => d.messagePath.id)
      .sort()
      .join("-");
  } else {
    return "Map";
  }
}
